<div #sidebar class="sidebar-container sidebar-preload">
  <!-- ANCHOR Logo link -->
  <div class="sidebar-logo-link">
    <a class="sidebar-top-logo">
      @if (logoLoading) {
        <i class="fas fa-spinner fa-pulse"></i>
      }
      @if (logoImgUrl) {
        <img
          [hidden]="logoLoading"
          (load)="onLogoLoad()"
          class="sidebar-top-logo-lg"
          [src]="logoImgUrl"
          alt="Logo"
        />
      }
    </a>
  </div>

  <!-- ANCHOR Sidebar -->
  <div
    class="sidebar-wrapper"
    [ngClass]="{
      'sidebar-hide': sidebarToggled,
      'sidebar-show': sidebarToggled == false
    }"
    (mouseenter)="openSidebar()"
    (mouseleave)="collapseSidebar()"
  >
    @if (sessionProfile != PROFILES.ABONADO && menuList) {
      <ul class="sidebar-nav custom-scrollbar--slim">
        <!-- ANCHOR Menu -->
        @for (menu of menuList; track menu.name; let i = $index) {
          @if (!menu.submenu && menu.profile && menu.client && !menu.hidden) {
            <li
              class="sidebar-menu"
              [ngClass]="{
                'sidebar-menu-disabled': menu.disabled,
                'sidebar-menu-active': activeMenu == menu.name
              }"
              [help]="menu.help | translate"
              [routerLink]="[menu.link]"
              (mouseenter)="menuActive = false; closeMenu()"
            >
              <a
                class="sidebar-nav-link"
                [ngClass]="{ 'sidebar-nav-link-toggled': sidebarToggled }"
              >
                <div>
                  <i class="{{ menu.icon }}"></i>
                  @if (!sidebarToggled) {
                    <span class="sidebar-menu-title">{{ menu.name | translate }}</span>
                  }
                </div>
              </a>
            </li>
          }
          <!-- ANCHOR Menu with submenu -->
          @if (
            menu.submenu &&
            menu.submenu.some(submenu => !submenu.hidden) &&
            menu.profile &&
            menu.client &&
            !menu.hidden
          ) {
            <li
              class="sidebar-menu"
              [help]="menu.help | translate"
              [ngClass]="{
                'sidebar-menu-disabled': menu.disabled,
                'sidebar-menu-active': activeMenu == menu.name
              }"
              [routerLink]="menu.link ? [menu.link] : null"
              (mouseenter)="menuActive = true; clearMenuTimeout(); openSubmenu($event.target, menu)"
              (mouseleave)="menuActive = false; closeMenu()"
            >
              <a
                class="sidebar-nav-link"
                [ngClass]="{ 'sidebar-nav-link-toggled': sidebarToggled }"
              >
                <div>
                  <i class="{{ menu.icon }}"></i>
                  @if (!sidebarToggled) {
                    <span class="sidebar-menu-title">{{ menu.name | translate }}</span>
                  }
                </div>
                @if (!sidebarToggled) {
                  <i class="fas fa-caret-right sidebar-menu-caret"></i>
                }
              </a>
            </li>
          }
        }
      </ul>
    }

    <!-- ANCHOR Submenu -->
    @if (activeSubmenu && !sidebarToggled) {
      <div
        class="sidebar-submenu"
        (mouseenter)="menuActive = true; clearMenuTimeout()"
        (mouseleave)="menuActive = false; closeMenu()"
      >
        <!-- Submenu > Title -->
        @for (submenu of activeSubmenu; track i; let i = $index) {
          <!-- ANCHOR Submenu without submenu -->
          @if (submenu.profile && submenu.client && !submenu.submenu && !submenu.hidden) {
            <button
              mat-menu-item
              [help]="submenu.help | translate"
              [routerLink]="[submenu.link]"
              [disabled]="submenu.disabled"
              (mouseenter)="activeSubmenuSubmenu = null"
            >
              <div class="sidebar-submenu-button">
                <div class="sidebar-icon-and-text">
                  <mat-icon class="material-menu-icon">
                    <i class="{{ submenu.icon }}"></i>
                    @if (submenu?.subicon) {
                      <i class="{{ submenu.subicon }} sidebar-nav-subicon"></i>
                    }
                  </mat-icon>
                  <span>{{ submenu.name | translate }}</span>
                </div>
                @if (submenu.shortcut) {
                  <div class="sidebar-shortcut">
                    <span class="keyboardkey">SHIFT</span>
                    <span class="keyboardkey">ALT</span>
                    <span class="keyboardkey">{{ submenu.shortcut }}</span>
                  </div>
                }
              </div>
            </button>
          }
          <!-- ANCHOR Submenu with submenu -->
          @if (submenu.profile && submenu.client && submenu.submenu && !submenu.hidden) {
            <button
              mat-menu-item
              [help]="submenu.help | translate"
              (mouseenter)="
                submenuActive = true; clearMenuTimeout(); openSubmenuSubmenu($event.target, submenu)
              "
              (mouseleave)="submenuActive = false; closeSubmenu()"
              [disabled]="submenu.disabled"
            >
              <div class="sidebar-submenu-button">
                <div class="sidebar-icon-and-text">
                  <mat-icon class="material-menu-icon">
                    <i class="{{ submenu.icon }}"></i>
                    @if (submenu?.subicon) {
                      <i class="{{ submenu.subicon }} sidebar-nav-subicon"></i>
                    }
                  </mat-icon>
                  <span>{{ submenu.name | translate }}</span>
                </div>
                <i class="fas fa-caret-right sidebar-submenu-caret"></i>
              </div>
            </button>
          }
        }
      </div>
    }

    <!-- ANCHOR Submenu of submenu -->
    @if (activeSubmenuSubmenu) {
      <div
        class="sidebar-submenu sidebar-submenu-submenu custom-scrollbar"
        (mouseenter)="menuActive = true; submenuActive = true; clearMenuTimeout()"
        (mouseleave)="menuActive = false; submenuActive = false; closeMenu()"
      >
        @for (submenu of activeSubmenuSubmenu; track submenu) {
          <!-- ANCHOR Submenu of submenu without submenu -->
          @if (submenu.profile && submenu.client && !submenu.submenu && !submenu.hidden) {
            <button
              mat-menu-item
              [help]="submenu.help | translate"
              [routerLink]="[submenu.link]"
              [disabled]="submenu.disabled"
              (mouseenter)="activeSubmenuSubmenuSubmenu = null"
            >
              <div class="sidebar-submenu-button">
                <div class="sidebar-icon-and-text">
                  <mat-icon class="material-menu-icon">
                    <i class="{{ submenu.icon }}"></i>
                    @if (submenu?.subicon) {
                      <i class="{{ submenu.subicon }} sidebar-nav-subicon"></i>
                    }
                  </mat-icon>
                  <span>{{ submenu.name | translate }}</span>
                </div>
                @if (submenu.shortcut) {
                  <div class="sidebar-shortcut">
                    <span class="keyboardkey">SHIFT</span>
                    <span class="keyboardkey">ALT</span>
                    <span class="keyboardkey">{{ submenu.shortcut }}</span>
                  </div>
                }
              </div>
            </button>
          }
          <!-- ANCHOR Submenu of submenu with submenu -->
          @if (submenu.profile && submenu.client && submenu.submenu && !submenu.hidden) {
            <button
              mat-menu-item
              [help]="submenu.help | translate"
              (mouseenter)="
                submenuSubmenuActive = true;
                clearMenuTimeout();
                openSubmenuSubmenuSubmenu($event.target, submenu)
              "
              (mouseleave)="submenuSubmenuActive = false; closeSubmenuSubmenu()"
              [disabled]="submenu.disabled"
            >
              <div class="sidebar-submenu-button">
                <div class="sidebar-icon-and-text">
                  <mat-icon class="material-menu-icon">
                    <i class="{{ submenu.icon }}"></i>
                    @if (submenu?.subicon) {
                      <i class="{{ submenu.subicon }} sidebar-nav-subicon"></i>
                    }
                  </mat-icon>
                  <span>{{ submenu.name | translate }}</span>
                </div>
                <i class="fas fa-caret-right sidebar-submenu-caret"></i>
              </div>
            </button>
          }
        }
      </div>
    }

    <!-- ANCHOR Submenu of submenu of submenu -->
    @if (activeSubmenuSubmenuSubmenu) {
      <div
        class="sidebar-submenu sidebar-submenu-submenu sidebar-submenu-submenu-submenu"
        (mouseenter)="
          menuActive = true; submenuActive = true; submenuSubmenuActive = true; clearMenuTimeout()
        "
        (mouseleave)="
          menuActive = false; submenuActive = false; submenuSubmenuActive = false; closeMenu()
        "
      >
        @for (submenu of activeSubmenuSubmenuSubmenu; track submenu) {
          @if (submenu.profile && submenu.client && !submenu.hidden) {
            <button
              mat-menu-item
              [help]="submenu.help | translate"
              [routerLink]="[submenu.link]"
              [disabled]="submenu.disabled"
            >
              <div class="sidebar-submenu-button">
                <div class="sidebar-icon-and-text">
                  <mat-icon class="material-menu-icon">
                    <i class="{{ submenu.icon }}"></i>
                    @if (submenu?.subicon) {
                      <i class="{{ submenu.subicon }} sidebar-nav-subicon"></i>
                    }
                  </mat-icon>
                  <span>{{ submenu.name | translate }}</span>
                </div>
                @if (submenu.shortcut) {
                  <div class="sidebar-shortcut">
                    <span class="keyboardkey">SHIFT</span>
                    <span class="keyboardkey">ALT</span>
                    <span class="keyboardkey">{{ submenu.shortcut }}</span>
                  </div>
                }
              </div>
            </button>
          }
        }
      </div>
    }

    <!-- ANCHOR Collapse menu -->
    <div class="sidebar-footer">
      <!-- Effects -->
      <div class="sidebar-effect">
        @if (activeTheme?.name == "water") {
          <app-water-effect
            [ngClass]="{ 'sidebar-water-effect-toggled': sidebarToggled }"
          ></app-water-effect>
        }
        @if (activeTheme?.name == "gas" || activeTheme?.name == "nortegas") {
          <app-gas-effect
            [ngClass]="{ 'sidebar-gas-effect-toggled': sidebarToggled }"
          ></app-gas-effect>
        }
        @if (activeTheme?.name == "nortegas") {
          <app-gas-effect></app-gas-effect>
        }
      </div>

      <!-- ANCHOR Logo Arson -->
      <div class="sidebar-logo">
        <span class="logo">
          <img
            class="img-fluid"
            [ngClass]="{ 'sidebar-logo-shine': activeTheme?.name == 'water' }"
            src="{{ sidebarLogo }}"
          />
        </span>
      </div>

      <!-- Menu lock -->
      @if (!sidebarToggled) {
        <div
          (click)="lockSidebar()"
          class="sidebar-lock pointer"
          [ngStyle]="{ opacity: sidebarLocked ? 1 : 0.5 }"
        >
          <i class="fa-solid fa-thumbtack"></i>
        </div>
      }
    </div>
  </div>
</div>
